import { gql } from "graphql-tag";

export const reportQuery = gql`
  query reportQuery($name: ReportName!, $dateStart: Int, $dateEnd: Int) {
    report(name: $name, dateStart: $dateStart, dateEnd: $dateEnd) {
      columns
      footer
      records
    }

    organization {
      id
      asksDobInterestQuestion
    }
  }
`;

export const reportSidebarQuery = gql`
  query ReportSidebarQuery {
    organization {
      id
      asksDobInterestQuestion
    }
  }
`;
